import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line-right",
  "use": "icon-line-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-line-right\">\n<g id=\"icon-line-right_Direction/line-right\">\n<g id=\"icon-line-right_icon/jiantou\">\n<path id=\"icon-line-right_chevron-down\" d=\"M6.45835 12.4583L5.53911 11.5391L9.07949 7.99868L5.53911 4.4583L6.45835 3.53906L10.918 7.99868L6.45835 12.4583Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/line-right.svg
// module id = xD4P
// module chunks = 140